// CEO 2026-10-07 · Signature DocuSign-style partagée (modal remettant, lien email, espace Prérec).
import { useState } from "react";
import { Input } from "../ui/input";
import SignaturePad from "./SignaturePad";

export function SignatureModeSwitch({ typed, setTyped, testid }) {
    const pill = (active) => `px-3 py-1.5 rounded-full font-bold transition ${active ? "bg-shariti-orange text-white" : "bg-slate-100 text-slate-500 hover:bg-slate-200"}`;
    return (
        <div className="flex items-center gap-2 justify-center text-xs">
            <button type="button" onClick={() => setTyped(true)} data-testid={`${testid}-typed`} className={pill(typed)}>
                Signature tapée
            </button>
            <button type="button" onClick={() => setTyped(false)} data-testid={`${testid}-drawn`} className={pill(!typed)}>
                Signature dessinée
            </button>
        </div>
    );
}

export function TypedSignaturePreview({ name, testid }) {
    const safe = (name || "").trim();
    const initials = safe.split(/\s+/).filter(Boolean).map((p) => p[0].toUpperCase()).slice(0, 3).join("");
    return (
        <div data-testid={testid} className="border-2 border-dashed border-shariti-orange/40 rounded-2xl p-6 bg-shariti-cream/30 text-center space-y-2">
            <div className="text-3xl text-shariti-black" style={{ fontFamily: "'Dancing Script', 'Brush Script MT', cursive" }}>
                {safe || "—"}
            </div>
            {initials && <div className="text-xs font-bold text-shariti-orange tracking-widest">{initials}</div>}
            <div className="text-[11px] text-slate-400 italic">
                Signature électronique — tape ton nom dans le champ au-dessus.<br />
                Elle sera horodatée + liée à ton compte dans le PDF archivé.
            </div>
        </div>
    );
}

export const encodeTypedSig = (name) => {
    if (!name || !name.trim()) return null;
    return `data:text/plain;base64,${btoa(unescape(encodeURIComponent(name.trim())))}`;
};

// Formulaire complet côté salarié : nom + mode + aperçu/pad + bouton.
export function RecipientSignForm({ defaultName, onSubmit, submitting, testid = "recipient-sign" }) {
    const [name, setName] = useState(defaultName || "");
    const [typed, setTyped] = useState(true);
    const [drawn, setDrawn] = useState(null);
    const ready = name.trim() && (typed || drawn);
    const submit = () => onSubmit({
        signature_data_uri: typed ? encodeTypedSig(name) : drawn,
        full_name: name.trim(),
        typed,
    });
    return (
        <div className="space-y-4" data-testid={`${testid}-form`}>
            <div>
                <div className="text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1">Nom du signataire</div>
                <Input value={name} onChange={(e) => setName(e.target.value)} data-testid={`${testid}-name`} />
            </div>
            <SignatureModeSwitch typed={typed} setTyped={setTyped} testid={`${testid}-mode`} />
            {typed ? (
                <TypedSignaturePreview name={name} testid={`${testid}-typed-preview`} />
            ) : (
                <SignaturePad onChange={(d, empty) => setDrawn(empty ? null : d)} testIdPrefix={`${testid}-pad`} />
            )}
            <p className="text-[11px] text-slate-500 italic text-center">
                En signant, {name.trim() || "le salarié"} reconnaît avoir reçu / restitué le matériel listé.
            </p>
            <button
                type="button"
                onClick={submit}
                disabled={!ready || submitting}
                data-testid={`${testid}-submit`}
                className="w-full h-11 rounded-full bg-shariti-orange text-white font-extrabold text-sm hover:bg-shariti-orange/90 transition disabled:opacity-50"
            >
                {submitting ? "Signature…" : "Signer le bon de remise"}
            </button>
        </div>
    );
}
